<template>
  <div id="app">
    <navigation></navigation>
      <router-view/>
      <v-dialog :clickToClose="false"></v-dialog>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import jwtDecode from 'jwt-decode'

export default {
  components: {
    Navigation
  },
  mounted: function() {
    if (this.$session.get('token')) {
      const username = jwtDecode(this.$session.get('token')).username
      this.$store.commit('setUsername', username)
    }
  }

}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#crisis-buttons .active {
  background-color: red !important;
  color: white !important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-active {
  opacity: 0;
}

.invalid-feedback {
	text-align: center;
}

#qr-authenticator canvas {
	transform: scaleX(-1);
}

</style>
